var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4375 17.0621V19.0934C15.4375 19.6321 15.2235 20.1488 14.8426 20.5297C14.4616 20.9106 13.945 21.1246 13.4062 21.1246H5.28125C4.74253 21.1246 4.22587 20.9106 3.84494 20.5297C3.46401 20.1488 3.25 19.6321 3.25 19.0934V6.90588C3.25 6.36716 3.46401 5.85051 3.84494 5.46957C4.22587 5.08864 4.74253 4.87463 5.28125 4.87463H13C14.1218 4.87463 15.4375 5.78413 15.4375 6.90588V8.93713",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6875 17.0624L22.75 12.9999L18.6875 8.93744",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9375 13.0013H21.9375",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log-out.70796400bec571bf329d506118461f36.svg";
export { ForwardRef as ReactComponent };